import { AnyLengthString } from 'aws-sdk/clients/comprehend';

export const ORDER_UPDATE_START = 'ORDER_UPDATE_START';
export const ORDER_UPDATE_SUCCESS = 'ORDER_UPDATE_SUCCESS';
export const ORDER_UPDATE_ERROR = 'ORDER_UPDATE_ERROR';
export const ORDER_UPDATE_LOADING = 'ORDER_UPDATE_LOADING';
export const ORDER_UPDATE_CANCEL = 'ORDER_UPDATE_CANCEL';

export const RESIN_ORDER_UPDATE_START = 'RESIN_ORDER_UPDATE_START';
export const RESIN_ORDER_UPDATE_SUCCESS = 'RESIN_ORDER_UPDATE_SUCCESS';
export const RESIN_ORDER_UPDATE_ERROR = 'RESIN_ORDER_UPDATE_ERROR';
export const RESIN_ORDER_UPDATE_LOADING = 'RESIN_ORDER_UPDATE_LOADING';
export const RESIN_ORDER_UPDATE_CANCEL = 'RESIN_ORDER_UPDATE_CANCEL';

export type Actions = {
    ORDER_UPDATE_START: { type: typeof ORDER_UPDATE_START, payload: any },
    ORDER_UPDATE_LOADING: { type: typeof ORDER_UPDATE_LOADING, payload: boolean },
    ORDER_UPDATE_SUCCESS: { type: typeof ORDER_UPDATE_SUCCESS, payload: any },
    ORDER_UPDATE_ERROR: { type: typeof ORDER_UPDATE_ERROR, payload: any },
    ORDER_UPDATE_CANCEL: { type: typeof ORDER_UPDATE_CANCEL, payload: any },
    RESIN_ORDER_UPDATE_START: { type: typeof RESIN_ORDER_UPDATE_START, payload: any },
    RESIN_ORDER_UPDATE_LOADING: { type: typeof RESIN_ORDER_UPDATE_LOADING, payload: boolean },
    RESIN_ORDER_UPDATE_SUCCESS: { type: typeof RESIN_ORDER_UPDATE_SUCCESS, payload: any },
    RESIN_ORDER_UPDATE_ERROR: { type: typeof RESIN_ORDER_UPDATE_ERROR, payload: any },
    RESIN_ORDER_UPDATE_CANCEL: { type: typeof RESIN_ORDER_UPDATE_CANCEL, payload: any },
  };
// Action Creators
export const actionCreators = {
  orderUpdateStart: (payload: any): Actions[typeof ORDER_UPDATE_START] => ({
    type: ORDER_UPDATE_START, payload,
  }),
  orderUpdateError: (payload: any): Actions[typeof ORDER_UPDATE_ERROR] => ({
    type: ORDER_UPDATE_ERROR, payload,
  }),
  orderUpdateSuccess: (payload: any): Actions[typeof ORDER_UPDATE_SUCCESS] => ({
    type: ORDER_UPDATE_SUCCESS, payload,
  }),
  orderUpdateLoading: (payload: boolean): Actions[typeof ORDER_UPDATE_LOADING] => ({
    type: ORDER_UPDATE_LOADING, payload,
  }),
  orderUpdateCancel: (payload: boolean): Actions[typeof ORDER_UPDATE_CANCEL] => ({
    type: ORDER_UPDATE_CANCEL, payload,
  }),
  resinOrderUpdateStart: (payload: any): Actions[typeof RESIN_ORDER_UPDATE_START] => ({
    type: RESIN_ORDER_UPDATE_START, payload,
  }),
  resinOrderUpdateError: (payload: any): Actions[typeof RESIN_ORDER_UPDATE_ERROR] => ({
    type: RESIN_ORDER_UPDATE_ERROR, payload,
  }),
  resinOrderUpdateSuccess: (payload: any): Actions[typeof RESIN_ORDER_UPDATE_SUCCESS] => ({
    type: RESIN_ORDER_UPDATE_SUCCESS, payload,
  }),
  resinOrderUpdateLoading: (payload: boolean): Actions[typeof RESIN_ORDER_UPDATE_LOADING] => ({
    type: RESIN_ORDER_UPDATE_LOADING, payload,
  }),
  resinOrderUpdateCancel: (payload: boolean): Actions[typeof RESIN_ORDER_UPDATE_CANCEL] => ({
    type: RESIN_ORDER_UPDATE_CANCEL, payload,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/orders/actions.ts